import { notify } from "@kyvg/vue3-notification";
import { useToast } from 'vue-toastification'
const toast = useToast()

import axios from 'axios'; 
const state = {
  cartItems:[],
  cartInfo:{}, 
  countCartItems: 0, 
  hold_sale_info:{},
  edit_sale_info:'',
  sale_id:'',
}

const mutations = {
  UPDATE_CART_ITEMS (state, payload) {  
    const cartItemProduct = JSON.stringify(payload);  
    const itemProduct = JSON.parse(cartItemProduct);  
    const newCartProduct = {
      product_id: itemProduct.id,
      product_subscription_id: itemProduct.product_subscription_id,
      subs_name: itemProduct.subs_name,
      product_name: itemProduct.name, 
      price: itemProduct.price, 
      discount_price: itemProduct.discount_price,  
      qty: itemProduct.min_order_qty ? itemProduct.min_order_qty : 1,
    }; 
    const cartProducts =  state.cartItems;
    let cartProductExists = false;
    cartProducts.map((cartProduct) => {
      console.log('newCartProduct', newCartProduct)
      console.log('product_subscription_id', cartProduct.product_subscription_id)
      console.log('product_id', cartProduct.product_id)
      if((cartProduct.product_id === newCartProduct.product_id) && (cartProduct.product_subscription_id === newCartProduct.product_subscription_id)){
        cartProduct.qty++;
        cartProductExists = true;
      }
    });
    if (!cartProductExists) cartProducts.push(newCartProduct); 
    //console.log(newCartProduct);    
  },
  UPDATE_HOLD_ITEMS (state, payload) {  
    const cartItemProduct = JSON.stringify(payload);  
    const itemProduct = JSON.parse(cartItemProduct); 
    const newCartProduct = {
      product_id: itemProduct.id,
      product_subscription_id: itemProduct.product_subscription_id,
      subs_name: itemProduct.subs_name,
      product_name: itemProduct.name, 
      price: itemProduct.price, 
      discount_price: itemProduct.discount_price, 
      product_code: itemProduct.code, 
      qty: Number(itemProduct.qty)
    }; 
    const cartProducts =  state.cartItems;
    let cartProductExists = false;
    cartProducts.map((cartProduct) => {
      if((cartProduct.product_id === newCartProduct.product_id) && (cartProduct.product_subscription_id === newCartProduct.product_subscription_id)){
        cartProduct.qty++;
        cartProductExists = true;
      }
    });
    if (!cartProductExists) cartProducts.push(newCartProduct);     
  },
  SELECT_CARTINFO (state, payload) { 
    Object.assign(state.cartInfo, payload);
  },
  removeAllFromcart: (state) =>{  
    state.cartItems.splice(0);
    state.hold_sale_info = {};
    state.countCartItems = 0;     
  }, 
  REMOVE_CART_INFO: (state, index) =>{  
  },
  REMOVE_CART_ITEMS: (state, index) =>{
    state.cartItems.splice(index, 1);  
  }, 
  UPDATE_HOLD_SALE: (state, payload) => {
    const proxyToObject = Object.assign({}, payload);  
    if( Object.keys(proxyToObject).length > 0){
      state.hold_sale_info = proxyToObject;
    }else{
      state.hold_sale_info = {};
    } 
  }
}

const actions = { 
  addCartItem ({ commit }, cartItem) {   
    commit('UPDATE_CART_ITEMS', cartItem);  
    toast.success("Added to the cart!",{ 
          timeout: 800 
    });     
  },
  addHoldItem ({ commit }, cartItem) {   
    commit('UPDATE_HOLD_ITEMS', cartItem);     
  },
  addHoldSale({ commit }, cartItem) {   
    commit('UPDATE_HOLD_SALE', cartItem);  
    //toast.success("Successfully added product to the cart!");     
  },
  selectCartInfo ({ commit }, infoData) {   
    commit('SELECT_CARTINFO', infoData);      
  },
  removeCartItem ({ commit },  index) {    
    commit('REMOVE_CART_ITEMS', index) 
  },
  removeCartInfo ({ commit },  index) {    
    commit('REMOVE_CART_INFO', index) 
  },
  removeAllCartItems ({ commit }) {
    commit('removeAllFromcart', '')
  }
}

const getters = { 
  saleId: state => state.sale_id,
  cartItems: state => state.cartItems,
  cartInfo: state => state.cartInfo,
  holdSaleInfo: state => state.hold_sale_info,
  cartTotal: state => {
    return state.cartItems.reduce((acc, cartItem) => {
      return (cartItem.qty * cartItem.price) + acc;
    }, 0).toFixed(2);
  },
  cartqty: state => {
    return state.cartItems.reduce((acc, cartItem) => {
      return cartItem.qty + acc;
    }, 0);
  }
} 

const cartModule = {
  state,
  mutations,
  actions,
  getters
}
export default cartModule;